import React, { useEffect } from "react";
import { seriesManagement } from "../../../../../utils/mainTabs/organize/seriesManagement";
import TickIcon from "../../../../../components/Common/SvgIcons/ManageIcons/TickIcon";
import { useNavigate, useOutletContext } from "react-router";
import classes from "./PublishSeries.module.scss";

const PublishSeries = () => {
  const navigate = useNavigate();
  const { pathType } = useOutletContext();
  const { tenantName, dataForUpdateProgramByID } = useOutletContext();
  useEffect(() => {
    setTimeout(() => {
      navigate(`${seriesManagement.path(tenantName)}`);
    }, 5000);
  }, []);
  return (
    <div className={classes.publisheMain}>
      <div className={classes.body}>
        <TickIcon fill={"#0da812"} />
        Series has been{" "}
        {pathType === "edit" &&
        dataForUpdateProgramByID?.[0]?.Programs?.IsPublished
          ? "Unpublished "
          : "Published "}
        Successfully.
        <div className={classes.linkRedirect}>
          You will be redirected to Series Management automatically after 5 sec
        </div>
      </div>
    </div>
  );
};

export default PublishSeries;
